import React from 'react';
import Genes from '../components/Genes';

const GenesPage = () => {
  return (
    <div className="page-container">
      <Genes />
    </div>
  );
};

export default GenesPage;